import { render, staticRenderFns } from "./whyChoose.vue?vue&type=template&id=0ec72ec6&scoped=true"
import script from "./whyChoose.vue?vue&type=script&lang=js"
export * from "./whyChoose.vue?vue&type=script&lang=js"
import style0 from "./whyChoose.vue?vue&type=style&index=0&id=0ec72ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec72ec6",
  null
  
)

export default component.exports